<template>
    <badge
        v-if="caption"
        :class="{ private: visibility === 0, network: visibility === 1, open: visibility === 2 }"
    >
        {{ caption }}
    </badge>
</template>

<script>
import Badge from './Badge.vue';

export default {
    name: 'OnGoingBadge',
    components: {
        Badge,
    },
    props: {
        visibility: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        caption() {
            switch (this.visibility) {
                case 0:
                    return this.$t('vfair.visibilityPrivate');
                case 1:
                    return this.$t('vfair.visibilityNetwork');
                case 2:
                    return this.$t('vfair.visibilityOpen');
                default:
                    return '';
            }
        },
    },
};
</script>

<style scoped>
.private {
    color: #f00;
    border-color: #f00;
}
.network {
    color: #07f;
    border-color: #07f;
}
.open {
    color: #000;
    border-color: #000;
}
</style>
